import { MaterialItem } from '../bus/material/types';
import $axios from '../utils/axios-instance';

export default class MaterialsApi {
  async getMaterialList() {
    return await $axios
      .get<{ data: MaterialItem[] }>('/v1/Material')
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getMaterialDetail(data: { id: number | string }) {
    return await $axios
      .get<MaterialItem>(`/v1/Material/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createMaterial(data: Omit<MaterialItem, 'id'>) {
    return await $axios
      .post('/v1/Material', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async changeMaterial(data: MaterialItem) {
    return await $axios
      .put(`/v1/Material/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteMaterial(data: { id: number | string }) {
    return await $axios
      .delete(`/v1/Material/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
